var _path, _rect, _path2, _g, _rect2, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplitView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19C12 19.5523 11.5523 20 11 20C10.4477 20 10 19.5523 10 19L10 3C10 2.44772 10.4477 2 11 2C11.5523 2 12 2.44772 12 3L12 19Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1924_966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 23,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.5,
    width: 21,
    height: 10,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9585 12.75L7.7085 10.125L9.62516 12.375L18.2502 8.625L23.0418 13.125",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1924_966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.921387 3.5H11.9589V19.5H0.921387V3.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1924_966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 23,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8.5,
    width: 21,
    height: 10,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.958496 15.75L6.7085 13.125L8.62516 15.375L17.2502 11.625L22.0418 16.125",
    stroke: "white",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1924_966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 6H14V22H23V6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitView);
export default __webpack_public_path__ + "static/media/Split_View.27a8b3c0cf70ac502b93856874937296.svg";
export { ForwardRef as ReactComponent };